module.exports = __webpack_public_path__ + "assets/images/spor_fm_tv4_logo_v2_1.89114b5cad3511c7869067b100e15095.png";